import { utilHelper } from "../../_helpers";
import {SUCCESSFUL_TRANSLATION_LABEL} from "../../../components/i18n/i18n";

const relativeUrl = 'api/personalTitle'

export const personalTitleService = {
    search,
    saveItem,
    updateItem,
    deleteItem,
    translate,
    sync,
    syncOnDemand
};

function search(offset, max, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', { data: data, showAlert: false })
}

function saveItem(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}`, 'POST', { data: data });
}

function updateItem(id, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'PUT', { data: data });
}

function deleteItem(id, fbDB) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}/${fbDB}`, 'DELETE',{})
}

function translate(id, data){
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/translate/${id}`, 'POST', { data: data, message:SUCCESSFUL_TRANSLATION_LABEL });
}

function sync(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/sync`, 'POST', {data, showAlert:false})
}

function syncOnDemand(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/syncItem`, 'POST', {data, showAlert:false})
}